<div class="app-shell">
  <div class="app-shell-header">
    <div class="app-shell-navbar-left">
      <img class="ascent-logo"
        src="./assets/ascent-logo.jpeg"
        (click)="navigateToHome()">
        @if (showProductSelector) {
          <lib-product-selector></lib-product-selector>
        }
      </div>
      @for (link of links; track link) {
        @if (!link.data?.isHidden) {
          <a class="app-shell-navbar-link"
            [routerLink]="generateLinkPath(link.path)"
            [ngClass]="{'active': isActiveLink(link.originalPath || link.path)}"
            title="{{ $safeNavigationMigration(link.data?.titleKey) | translate: 'navigation' }}"> <span>{{ $safeNavigationMigration(link.data?.titleKey) | translate: 'navigation' }}</span>
          </a>
        }
      }
      @if (!appSettings.isProduction) {
        @if (!isDarkTheme) {
          <div
            class="app-shell-navbar-link theme ms-auto me-4"
          (click)="applyDarkTheme()">Dark</div>
        }
        @if (isDarkTheme) {
          <div
            class="app-shell-navbar-link theme ms-auto me-4"
          (click)="applyLightTheme()">Light</div>
        }
      }
      <div class="app-settings me-1"
        [class.ms-auto]="appSettings.isProduction">
        <svg-icon [src]="iconSet.settings"
          class="eshava-ascent-svg"
        (click)="navigateToSettings()"></svg-icon>
      </div>
      <div class="app-sign-out me-4"
        title="{{username}} &ndash; {{ 'SignOut' | translate:'ascent' }}"
        (click)="signOut()">
        @if (!userThumbnail) {
          <svg-icon
            [src]="iconSet.arrowRightBracket"
          class="eshava-ascent-svg"></svg-icon>
        }
        @if (userThumbnail) {
          <img class="user-thumbnail"
            [src]="userThumbnail">
        }
      </div>
    </div>
    <div class="app-shell-content">
      <div class="app-shell-content-wrapper">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <lib-context-menu></lib-context-menu>